import { useMemo } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { categoryFilterOptions, categoryIdsInPeriod } from "../../utils/financeCategoryFilter";

export default function FinanceCategoryFilter({
  categories = [],
  transactions = [],
  value = [],
  onChange,
  sx,
}) {
  const presentIds = useMemo(() => categoryIdsInPeriod(transactions), [transactions]);
  const options = useMemo(
    () => categoryFilterOptions(categories, presentIds),
    [categories, presentIds]
  );
  const selected = (value || []).map(String);
  const selectedSet = useMemo(() => new Set(selected), [selected]);

  return (
    <FormControl size="small" sx={sx}>
      <InputLabel>Kategorier</InputLabel>
      <Select
        multiple
        label="Kategorier"
        value={selected}
        onChange={(event) => onChange(event.target.value)}
        renderValue={(ids) => {
          if (!ids.length) return "";
          if (ids.length === 1) {
            return options.find((opt) => opt.id === ids[0])?.label || "1 valgt";
          }
          return `${ids.length} valgt`;
        }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 320 } } }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id} sx={{ py: 0.25 }}>
            <Checkbox checked={selectedSet.has(opt.id)} size="small" />
            <ListItemText
              primary={opt.label}
              sx={{ my: 0, pl: opt.indent ? 1.5 : 0 }}
              primaryTypographyProps={{
                variant: "body2",
                fontWeight: opt.indent ? 400 : 600,
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
